import { useContext } from 'react'
import { DefaultTheme, ThemeContext } from 'styled-components'

const giphyCharcoal = '#4a4a4a'
const giphyRed = '#ff6666'
const giphyIndigo = '#6157ff'

const palette = {
  /* greys */
  giphyBlack: '#121212',
  giphyDarkestGrey: '#212121',
  giphyDarkGrey: '#2e2e2e',
  giphyDarkCharcoal: '#3e3e3e',
  giphyCharcoal: giphyCharcoal,
  giphyLightCharcoal: '#5c5c5c',
  giphyLightGrey: '#a6a6a6',
  giphyLightestGrey: '#d8d8d8',
  giphyWhite: '#ffffff',

  /* primary */
  giphyBlue: '#00ccff',
  giphyGreen: '#00ff99',
  giphyPurple: '#9933ff',
  giphyRed: giphyRed,
  giphyYellow: '#fff35c',

  /* secondary */
  giphyAqua: '#00e6cc',
  giphyLightBlue: '#3191ff',
  giphyIndigo: giphyIndigo,
  giphyPink: '#e646b6',

  /* social */
  facebook: '#3894fc',
  twitter: '#00ccff',
  pinterest: '#e54cb5',
  tumblr: '#529ecc',
  instagram: '#c23c8d',
  reddit: '#fc6669',
  sms: '#00ff99',

  /* functional */
  error: giphyRed,
  delete: giphyRed,
  primaryCTA: giphyIndigo,
  primaryCTADisabled: '#241F74',
  secondaryCTA: giphyCharcoal,
  dim: `rgba(0, 0, 0, 0.8)`,
  gifOverlay: `rgba(0, 0, 0, 0.4)`,

  /* code-example */
  codeCopyText: '#5C5C5C',

  /* sdk-features */
  featureBackground: '#F8F8F8',
} as const

export const theme: DefaultTheme = {
  blockTextHeight: 420,
  containerMobilePadding: 14,
  containerPadding: 6,
  containerWidth: 1140,
  contentWidth: 860,
  disableMobileQueries: false,
  headerHeight: 66,
  headerMargin: 30,
  sectionMargin: 130,
  sectionMobileMargin: 60,
  sidebarWidth: 250,
  palette,
}

export function useTheme() {
  return useContext(ThemeContext)
}
